/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type VisibilityBoardRow_rowData$ref = any;
export type VisibilityBoardLocationStatusesDisplay = "HIDDEN" | "VISIBLE" | "%future added value";
export type VisibilityBoardInput = {|
  name: string,
  description: string,
  templateId: any,
  footer?: ?string,
  scrollDuration?: ?number,
  timeHeaderFormat?: ?string,
  locationStatusesDisplay?: ?VisibilityBoardLocationStatusesDisplay,
  departmentBedConfig: string,
|};
export type visibilityBoard_modifyVisibilityBoardEntry_MutationVariables = {|
  visibilityBoardId: any,
  visibilityBoardInput: VisibilityBoardInput,
|};
export type visibilityBoard_modifyVisibilityBoardEntry_MutationResponse = {|
  +visibilityBoardMutation: ?{|
    +modifyVisibilityBoardEntry: ?{|
      +$fragmentRefs: VisibilityBoardRow_rowData$ref
    |}
  |}
|};
export type visibilityBoard_modifyVisibilityBoardEntry_Mutation = {|
  variables: visibilityBoard_modifyVisibilityBoardEntry_MutationVariables,
  response: visibilityBoard_modifyVisibilityBoardEntry_MutationResponse,
|};
*/


/*
mutation visibilityBoard_modifyVisibilityBoardEntry_Mutation(
  $visibilityBoardId: UUID!
  $visibilityBoardInput: VisibilityBoardInput!
) {
  visibilityBoardMutation {
    modifyVisibilityBoardEntry(visibilityBoardId: $visibilityBoardId, visibilityBoardInput: $visibilityBoardInput) {
      ...VisibilityBoardRow_rowData
      id
    }
  }
}

fragment VisibilityBoardRow_rowData on VisibilityBoard {
  id
  name
  description
  boardTemplate {
    id
    name
  }
  departmentExchangeName
  bedExchangeNames
  footer
  scrollDuration
  timeHeaderFormat
  locationStatusesDisplay
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "visibilityBoardId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "visibilityBoardInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "visibilityBoardId",
    "variableName": "visibilityBoardId"
  },
  {
    "kind": "Variable",
    "name": "visibilityBoardInput",
    "variableName": "visibilityBoardInput"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "visibilityBoard_modifyVisibilityBoardEntry_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VisibilityBoardMutation",
        "kind": "LinkedField",
        "name": "visibilityBoardMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "VisibilityBoard",
            "kind": "LinkedField",
            "name": "modifyVisibilityBoardEntry",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VisibilityBoardRow_rowData"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "visibilityBoard_modifyVisibilityBoardEntry_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VisibilityBoardMutation",
        "kind": "LinkedField",
        "name": "visibilityBoardMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "VisibilityBoard",
            "kind": "LinkedField",
            "name": "modifyVisibilityBoardEntry",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BoardTemplate",
                "kind": "LinkedField",
                "name": "boardTemplate",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "departmentExchangeName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bedExchangeNames",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "footer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scrollDuration",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeHeaderFormat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locationStatusesDisplay",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4d45fa798405882eb4ec658537e4e4a5",
    "id": null,
    "metadata": {},
    "name": "visibilityBoard_modifyVisibilityBoardEntry_Mutation",
    "operationKind": "mutation",
    "text": "mutation visibilityBoard_modifyVisibilityBoardEntry_Mutation(\n  $visibilityBoardId: UUID!\n  $visibilityBoardInput: VisibilityBoardInput!\n) {\n  visibilityBoardMutation {\n    modifyVisibilityBoardEntry(visibilityBoardId: $visibilityBoardId, visibilityBoardInput: $visibilityBoardInput) {\n      ...VisibilityBoardRow_rowData\n      id\n    }\n  }\n}\n\nfragment VisibilityBoardRow_rowData on VisibilityBoard {\n  id\n  name\n  description\n  boardTemplate {\n    id\n    name\n  }\n  departmentExchangeName\n  bedExchangeNames\n  footer\n  scrollDuration\n  timeHeaderFormat\n  locationStatusesDisplay\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e49fa7ce9db67bf17e21ca5af0b319b0';

module.exports = node;
